export default "__VITE_ASSET__B6s5R8l0__"